import { localizationService } from '@shared-services/localization-service';
import React from 'react';
import styled from 'styled-components';
import { useBookingContext } from '../../Context';
import strings from '../../strings';
import { getFormattedPriceStr, shouldUsePaidBooking } from '../../utils';
import PricingIcon from '../icons/PricingIcon';

const { str } = localizationService;

const BookingPricingMetaSection = () => {
    const bookerContext = useBookingContext();
    const isPaidBooking = shouldUsePaidBooking(bookerContext);
    const priceValue = getFormattedPriceStr(bookerContext);

    let taxesValue = '';

    if (isPaidBooking && bookerContext.basePrice) {
        if (bookerContext.taxIncluded && bookerContext.taxPercentage) {
            taxesValue = str(strings.priceIncludesTax, {
                taxPercentage: bookerContext.taxPercentage.toLocaleString(
                    undefined,
                    {
                        style: 'percent',
                    }
                ),
            });
        }
    }

    return (
        <Container className='cal-booking-price-meta-section'>
            <BasePriceInfo>
                <Icon aria-hidden='true' width={18} height={18} />
                <Price data-auto='cal-booking-price-value'>{priceValue}</Price>
            </BasePriceInfo>

            {!!taxesValue && (
                <>
                    <Text data-auto='cal-booking-price-tax-value'>
                        {taxesValue}
                    </Text>
                    <Text>{str(strings.priceMightChangeMessage)}</Text>
                </>
            )}
        </Container>
    );
};

export default BookingPricingMetaSection;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.875rem;
    line-height: 1.25rem;
    margin-bottom: var(--cal-spacing-4);
    font-weight: 500;
    gap: var(--cal-spacing-2);
`;

const BasePriceInfo = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--cal-spacing-2);
`;

const Icon = styled(PricingIcon)`
    fill: transparent;
    flex-shrink: 0;
    // need to align with other cal icons
    margin-inline: -1px;
`;

const Price = styled.div`
    position: relative;
    max-width: 100%;
    word-break: break-word;
`;

const Text = styled.div``;
